import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Col, Container, Nav, NavItem, Row } from 'reactstrap';
import { MemoraLogoWhite } from '../assets';
import '../assets/sass/landing.scss';
import Navbar from '../components/Navbar';
import About from '../views/About';
import Blog from '../views/Blog';
import Landing from '../views/Landing';
import Price from '../views/Price';
import Timeline_main from '../views/Timeline_main';
import Features from '../views/Features';
import Faq from '../views/Faq';
import FutureMessages_main from '../views/FutureMessages_main';
import BlogDetails from '../views/BlogDetails';
import CustomAlert from '../components/Modals/CustomAlert';
import PublicMemoirs from '../views/PublicMemoirs';
const MainLayout = () => {
	const [search, setSearch] = useState('');
	const { themeType } = useSelector(state => state.theme);
	return (
		<>
			<CustomAlert />
			<header>
				<div className='navigation'>
					<Container fluid>
						<Navbar search={search} setSearch={setSearch} />
					</Container>
				</div>
			</header>
			<Switch>
				<Route path='/main' exact component={Landing} />
				<Route path='/main/about' exact component={About} />
				<Route
					path='/main/PublicMemoirs'
					exact
					render={props => (
						<PublicMemoirs {...props} search={search} />
					)}
				/>
				<Route path='/main/blog' exact component={Blog} />
				<Route path='/main/price' exact component={Price} />
				<Route path='/main/Features' exact component={Features} />
				<Route path='/main/faq' exact component={Faq} />
				<Route
					path='/main/timeline/:id'
					exact
					component={Timeline_main}
				/>
				<Route path='/main/blog/:id' exact component={BlogDetails} />
				<Route
					path='/main/future-messages/:id'
					exact
					component={FutureMessages_main}
				/>
			</Switch>
			<footer>
				<Container>
					<Row className='align-items-center'>
						<Col xl='4'>
							<img src={MemoraLogoWhite} />
						</Col>
						<Col xl='8'>
							<Nav>
								<NavItem>
									<NavLink
										className='text-white mr-4'
										onClick={e => window.scrollTo(0, 0)}
										to='/main/about'
									>
										About Us
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className='text-white mx-4' to='#'>
										Features
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className='text-white mx-4'
										onClick={e => window.scrollTo(0, 0)}
										to='/main/price'
									>
										Price
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className='text-white mx-4'
										onClick={e => window.scrollTo(0, 0)}
										to='/main/blog'
									>
										Blog
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className='text-white mx-4' to='#'>
										Site map
									</NavLink>
								</NavItem>
							</Nav>
						</Col>
					</Row>
					<Row className='align-items-center mt-3'>
						<Col xl='4'>
							<div className='social-links'>
								<div className='social-link'>
									<i className='fa fa-facebook-f'></i>
								</div>
								<div className='social-link'>
									<i className='fa fa-twitter'></i>
								</div>
								<div className='social-link'>
									<i className='fa fa-instagram'></i>
								</div>
								<div className='social-link'>
									<i className='fa fa-youtube'></i>
								</div>
							</div>
						</Col>
						<Col xl='8'>
							<Row>
								<Col md='5'>
									<small className='d-flex text-white'>
										<i className='fa fa-map-marker-alt mr-2 mt-1'></i>
										113 Sassnex, White House, USA
									</small>
								</Col>
								<Col md='4'>
									<small className='d-flex text-white'>
										<i className='fa fa-phone mr-2 mt-1'></i>
										+001-548-159-2491
									</small>
								</Col>
								<Col md='3'>
									<small className='d-flex text-white'>
										<i className='fa fa-envelope-o mr-2 mt-1'></i>
										info@yourdomain.com
									</small>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className='align-items-center mt-2'>
						<Col xl={{ offset: 4, size: 8 }}>
							<Row>
								<Col md='4'>
									<small className='d-flex text-white'>
										Privacy Policy
									</small>
								</Col>
								<Col md='4'>
									<small className='d-flex text-white'>
										Program terms and conditions
									</small>
								</Col>
								<Col md='4'>
									<small className='d-flex text-white'>
										Data protection policy
									</small>
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
			</footer>
		</>
	);
};

export default MainLayout;
